import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
export function ScrollProgressBar() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 26,
    restDelta: 0.001
  });
  return <motion.div aria-hidden="true" style={{
    scaleX,
    willChange: 'transform'
  }} className="fixed inset-x-0 top-0 z-[60] h-[3px] origin-left bg-gradient-to-r from-electric via-grape to-magenta shadow-[0_0_14px_rgba(236,30,156,0.8)]" data-id="element-129" data-mp="wibcbqdhv1k9" />;
}